import { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Form,
} from "reactstrap";
import classnames from "classnames";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useFormik } from "formik";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import * as Yup from "yup";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../Components/Common/Loader";
import { useExpert, useUpdateExpert } from "../../hooks/useExperts";
SwiperCore.use([FreeMode, Navigation, Thumbs]);

function ExpertValidation(props) {
  const { id } = useParams();
  const history = useHistory();

  const expertQ = useExpert(id);
  const updateExpert = useUpdateExpert();

  const selectAticle = useMemo(() => expertQ.data || {}, [expertQ.data]);
  const competences = selectAticle?.competences || [];
  const references = selectAticle?.references || [];

  const userDisplayName = useMemo(() => {
    const p = selectAticle?.user?.profile;
    const fullName = `${p?.last_name || selectAticle?.user?.last_name || ""} ${
      p?.first_name || selectAticle?.user?.first_name || ""
    }`.trim();
    return fullName || selectAticle?.user?.username || "-";
  }, [selectAticle?.user]);

  const userPhoto =
    selectAticle?.user?.profile_pic ||
    selectAticle?.user?.profile?.profile_pic ||
    "";

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      is_expert: Boolean(selectAticle?.is_expert),
    },

    validationSchema: Yup.object({
      validated: Yup.boolean(),
    }),

    onSubmit: (values) => {
      const run = async () => {
        try {
          const payload = {
            id: selectAticle.id,
            is_expert: values.is_expert,
          };
          await updateExpert.mutateAsync({ id, payload });
          validation.resetForm();
          history.push("/experts");
        } catch (_e) {
          // handled by hook
        }
      };
      run();
    },
  });

  if (expertQ.isLoading) return <Loader />;
  if (expertQ.isError)
    return <Loader error={expertQ.error?.message || props.t("Erreur")} />;

  document.title = props.t("Validation d'un expert");
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Validation d'un expert")}
          pageTitle={props.t("Experts")}
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={12}>
                    <div className="mt-xl-0 mt-5">
                      <div>
                        <div className="d-flex">
                          <img
                            src={userPhoto}
                            width="100"
                            style={{
                              borderRadius: "50%",
                              height: "100px",
                              width: "100px",
                              objectFit: "cover",
                              objectPosition: "center center",
                              paddingBottom: "10px",
                            }}
                            alt=""
                          />
                          <div
                            style={{
                              marginLeft: "20px",
                              marginTop: "8px",
                            }}
                          >
                            <h2
                              style={{
                                fontWeight: "bold",
                                textTransform: "uppercase",
                              }}
                            >
                              {userDisplayName}
                            </h2>
                            <span className="text-xl fw-medium">
                              <p>{selectAticle.profession}</p>
                              <p className="text-muted">
                                {selectAticle.last_certificate}
                              </p>
                            </span>
                            <br />
                          </div>
                        </div>
                      </div>

                      <span className="text-xl fw-medium">
                        {competences &&
                          competences.map((item, key) => {
                            return (
                              <div
                                className="text-xl fw-medium badge badge-soft-warning"
                                key={key}
                              >
                                {item.label}
                              </div>
                            );
                          })}
                      </span>

                      <div className="product-content mt-3">
                        <Nav tabs className="nav-tabs-custom nav-success">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "1",
                              })}
                              onClick={() => {
                                toggleCustom("1");
                              }}
                            >
                              {props.t("Détails")}
                            </NavLink>
                          </NavItem>
                        </Nav>

                        <TabContent
                          activeTab={customActiveTab}
                          className="border border-top-0 p-4"
                          id="nav-tabContent"
                        >
                          <TabPane id="nav-speci" tabId="1">
                            <div className="table-responsive">
                              <table className="table mb-0">
                                <tbody>
                                  <tr>
                                    <th scope="row">
                                      {" "}
                                      {props.t("Curriculum Vitae")}
                                    </th>
                                    <td>
                                      {selectAticle.cv ||
                                        props.t("(Non Renseigné)")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">
                                      {" "}
                                      {props.t("Références")}{" "}
                                    </th>
                                    <td>
                                      {references && references.length > 0
                                        ? references.map((item, key) => {
                                            return (
                                              <span
                                                className="text-xl fw-medium "
                                                key={key}
                                              >
                                                {item.phone_number}
                                              </span>
                                            );
                                          })
                                        : props.t("(Non Renseigné)")}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Form
                  encType="multipart/form-data"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  <br></br>
                  <input
                    type="checkbox"
                    name="is_expert"
                    className="form"
                    style={{
                      fontWeight: "30px",
                      width: "20px",
                      height: "20px",
                      marginRight: "5px",
                    }}
                    checked={validation.values.is_expert}
                    onChange={validation.handleChange}
                  />
                  <b> Je valide cet expert </b>
                  <div className="text-end mb-3">
                    <Link to="/experts" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                    <button type="submit" className="btn btn-warning">
                      {props.t("Valider l'expert")}
                    </button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

ExpertValidation.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(ExpertValidation));
